import { EmptyState, FlexBox, Spinner } from '@dixa/lib-shared-habla';
import classNames from 'classnames';

import styles from './searchResultsLoading.module.scss';

type SearchResultsLoadingProps = {
  /**
   * Whether to overlay the parent element. The parent element should have
   * `position: relative`.
   */
  isOverlay?: boolean;
};

export const SearchResultsLoading = ({
  isOverlay = false,
}: SearchResultsLoadingProps): JSX.Element => {
  return (
    <FlexBox
      className={classNames(styles.root, {
        [styles.rootOverlaid]: isOverlay,
      })}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      gap="400"
    >
      <Spinner />

      <EmptyState
        title="Searching..."
        description="Please wait a moment"
        icon={null}
      />
    </FlexBox>
  );
};
